import {BrowserRouter, Route,Switch} from 'react-router-dom'
import Home from './Pages/Home';
import Appbar from './Components/Appbar'
import Register from './Pages/Register';
import Verify from './Pages/Verify';
import {ThemeProvider} from '@mui/material'
import {createTheme} from "@mui/material/styles"
import VerifyCode from './Pages/VerifyCode';
import IdCard from './Pages/IdCard';
import About from './Pages/About';
import Bank from './Pages/Bank';
import Hospital from './Pages/Hospital';
import HospitalService from './Pages/Hospital/HospitalService';
import VerifyBank from "./Pages/Bank/VerifyBank"
import VerifySchool from "./Pages/School/VerifySchool"
import VerifyHospital from "./Pages/Hospital/VerifyHospital"
import SchoolService from "./Pages/School/SchoolService"
import RegistrationForm from './Pages/Register/RegistrationForm';
import VerifyRegistration from './Pages/Register/VerifyRegistration';
import BankService from './Pages/Bank/BankService';
import { amber, blueGrey, green, indigo, orange, purple, red, teal, yellow } from '@mui/material/colors';
import School from './Pages/School';
const customTheme=createTheme({
  palette:{
    primary:teal,
    background:{
      main:"#252827",
    },
    danger: red,
    success:green

  },
  typography: {
    fontFamily: [
      "Oswald",
      '-apple-system',
      'BlinkMacSystemFont',
      '"Segoe UI"',
      'Roboto',
      '"Helvetica Neue"',
      'Arial',
      'sans-serif',
      '"Apple Color Emoji"',
      '"Segoe UI Emoji"',
      '"Segoe UI Symbol"',
    ].join(','),
  },

})

function App() {
  return (
    <BrowserRouter>       
      <ThemeProvider theme={customTheme}>
        <Appbar/>
        <Switch>
            <Route path="/" exact component={Home}/>
            <Route path="/verify/:id" exact component={Verify}/>
            <Route path="/verify" exact component={VerifyCode}/>
            <Route path="/register" exact component={Register}/>
            <Route path="/register/registrationForm" exact component={RegistrationForm}/>
            <Route path="/register/verifyRegistration" exact component={VerifyRegistration}/>
            <Route path="/id/:id" exact component={IdCard}/>
            <Route path="/about" exact component={About}/>
            <Route path="/bank" exact component={Bank}/>
            <Route path="/bank/verifyBank" exact component={VerifyBank}/>
            <Route path="/bank/BankService" exact component={BankService}/>
            <Route path="/school" exact component={School}/>
            <Route path="/school/verifySchool" exact component={VerifySchool}/>
            <Route path="/school/schoolService" exact component={SchoolService}/>
            <Route path="/hospital" exact component={Hospital}/>
            <Route path="/hospital/verifyHospital" exact component={VerifyHospital}/>
            <Route path="/hospital/hospitalService" exact component={HospitalService}/>
        </Switch>
        
      </ThemeProvider>
  </BrowserRouter>
  );
}

export default App;
